import { styled } from '../../../styled/index'

export default styled.div`
  width: 20px;
  height: 20px;
`
